export default [
  {
    path: '/map',
    name: 'map',
    meta: {
      login: true
    }
  },
  { path: '/map/MapConfigControl', name: 'MapConfigControl', component: resolve => require(['@/views/map/MapConfigControl'], resolve) },
  { path: '/map/flowToSum', name: 'flowToSum', component: resolve => require(['@/views/map/flowToSum'], resolve) },
  { path: '/map/OperationBoard', name: 'OperationBoard', component: resolve => require(['@/views/map/OperationBoard'], resolve) },
  { path: '/map/MapAisConfig', name: 'MapAisConfig', component: resolve => require(['@/views/map/MapAisConfig'], resolve) },
  { path: '/map/VesselConfigControl', name: 'VesselConfigControl', component: resolve => require(['@/views/map/VesselConfigControl'], resolve) },
  { path: '/map/TreasureShipData', name: 'TreasureShipData', component: resolve => require(['@/views/map/TreasureShipData'], resolve) },
  { path: '/map/DifferentialDataProofreading', name: 'DifferentialDataProofreading', component: resolve => require(['@/views/map/DifferentialDataProofreading'], resolve) },
  { path: '/map/VesselNameControl', name: 'VesselNameControl', component: resolve => require(['@/views/map/VesselNameControl'], resolve) },
  { path: '/map/ErrorLogControl', name: 'ErrorLogControl', component: resolve => require(['@/views/map/ErrorLogControl'], resolve) },
  { path: '/map/ResourceGroupControl', name: 'ResourceGroupControl', component: resolve => require(['@/views/map/ResourceGroupControl'], resolve) },
  {
    path: '/map/PortStandardizingControl',
    name: 'PortStandardizingControl',
    component: resolve => require(['@/views/map/PortStandardizingControl'], resolve)
  },
  { path: '/map/RouteReference', name: 'RouteReference', component: resolve => require(['@/views/map/RouteReference'], resolve) },
  { path: '/map/CargoForecast', name: 'CargoForecast', component: resolve => require(['@/views/map/CargoForecast'], resolve) },
  {
    path: '/map/DailyForecastFilling',
    name: 'DailyForecastFilling',
    component: resolve => require(['@/views/map/DailyForecastFilling'], resolve)
  },
  {
    path: '/map/ElectronicFence',
    name: 'ElectronicFence',
    component: resolve => require(['@/views/map/ElectronicFence'], resolve)
  },
  {
    path: '/map/MonthlyForecastFormula',
    name: 'MonthlyForecastFormula',
    component: resolve => require(['@/views/map/MonthlyForecastFormula'], resolve)
  },
  {
    path: '/map/PXPredication',
    name: 'PXPredication',
    component: resolve => require(['@/views/map/PXPredication'], resolve)
  },
  { path: '/map/VesselPath', name: 'VesselPath', component: resolve => require(['@/views/map/VesselPath'], resolve) },
  { path: '/map/OpenLink', name: 'OpenLink', component: resolve => require(['@/views/map/OpenLink'], resolve) },
  { path: '/map/PortGroupControl', name: 'PortGroupControl', component: resolve => require(['@/views/map/PortGroupControl'], resolve) },
  { path: '/cargoFlowtoPredication', name: 'cargoFlowtoPredication', component: resolve => require(['@/views/map/CargoFlowtoPredication'], resolve) }
]



// WEBPACK FOOTER //
// ./src/config/router/map.js